export const TemplateCategory = {
  APPOINTMENT: "APPOINTMENT",
  THERAPY: "THERAPY",
  NOTIFY_OWNER: "NOTIFY_OWNER"
};
